import PropTypes from 'prop-types';

import { productsCategories } from 'constants/products';

const checkoutCategoryProp = PropTypes.oneOf([
  productsCategories.HAIRCARE,
  productsCategories.SKINCARE,
]);

export default checkoutCategoryProp;
